import React, { useState } from "react";
import "./feedback.css";
import { useAlert } from "react-alert";
import { postData } from "../common/utils";

function Feedback() {
  const [feedback, setFeedback] = useState('');
  const [feedbackType, setFeedbackType] = useState('0');
  const [disabled, setDisabled] = useState(false);
  const alert = useAlert();

  const feedbackSubmit = (e) => {
    e.preventDefault();
    //Bug was === and ! together didnt work properly
    if (feedback !== '' && feedbackType !== '0') {
      setDisabled(true);
      postData(process.env.REACT_APP_API_URL + "api/feedback/create", {
        type: feedbackType,
        feedback: feedback,
      }).then((data) => {
        setDisabled(false);
        if (data.issuccessful == true) {
          alert.success('Feedback submitted');
          setFeedback('');
          setFeedbackType('0');
        } else {
          alert.error('Error: ' + data.message);
        }
      });
    } else if (feedbackType == '0') {
      alert.error('Please select feedback type');
    } else if (feedback == '') {
      alert.error('Please enter your feedback');
    }
  };

  return (
    <section>
      <div className="tt-title-wrap">
        <div className="tt-title">
          <h1>Share feedback or Report bugs</h1>
        </div>
      </div>
      <form className="feedback-form" onSubmit={(e) => feedbackSubmit(e)}>
        <div>
          {/* <label htmlFor="ddlType" className="txt-label">Type</label> */}
          <select name="ddlType" id="ddlType" className="fb-select" value={feedbackType} onChange={(e) => setFeedbackType(e.target.value)}>
            <option value="0">Select type of feedback</option>
            <option value="Bug">Bug</option>
            <option value="Suggestion">Suggestion</option>
          </select>
        </div>
        <div>
          <textarea name="txtFeedback" id="txtFeedback" cols="30" rows="5" className="txt-input fb-textarea" placeholder="Feedback message" onChange={(e) => setFeedback(e.target.value)} value={feedback}></textarea>
        </div>
        <div>
          <button className="blue-btn fb-btn" disabled={disabled}>{disabled ? 'Loading...' : 'Submit'}</button>
        </div>
      </form>
    </section>
  );
}

export default Feedback;
